/* global tinyMCE */
import { useEffect, useState } from "react";
import AiProvider from "./AiProvider";
import { lazyAiComponent } from "./lazyAiComponent";

const AiAssist = lazyAiComponent("AiAssist");

const AiAssistant = ({
  align,
  contactUuid,
  context,
  messageType = "Generic",
  onInsertClick,
  side,
  textareaId,
  isTinyMce,
}) => {
  const [tinyMceDocument, setTinyMceDocument] = useState(null);

  useEffect(() => {
    if (!isTinyMce || tinyMceDocument) return;
    const timeoutId = setInterval(() => {
      // With several editors mounted, activeEditor is whichever last held the cursor;
      // a caller that passes textareaId gets pinned to its own editor instance instead.
      const editor = textareaId ? tinyMCE.get(textareaId) : tinyMCE.activeEditor;
      if (editor) setTinyMceDocument(editor.contentDocument);
    }, 500);
    return () => {
      clearInterval(timeoutId);
    };
  }, [isTinyMce, tinyMceDocument, textareaId]);

  return (
    <AiProvider>
      <AiAssist
        align={align}
        contactUuid={contactUuid}
        context={context}
        messageType={messageType}
        onInsertClick={onInsertClick}
        side={side}
        textareaId={textareaId}
        tinyMceDocument={tinyMceDocument}
      />
    </AiProvider>
  );
};

export default AiAssistant;
